import React from "react";
import { StyledHomePageHowItWorkBlock, StyledHomePageHowItWorkSection } from "./styledHowItWork";
import { StyledHomePageContainer, StyledMainTitleHomePage } from "../styledHomePage";
import ContentParentDesktop from "./ContentParentDesktop";
import ContentParentResponse from "./ContentParentResponse";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const HomePageHowItWork = () => {

  const howItWorkTitleAnimation = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: {
      x: 0,
      opacity: 1,
      transition: { delay: 0.2 }
    }
  };

  return (
    <StyledHomePageHowItWorkSection>
      <StyledHomePageContainer>
        <StyledHomePageHowItWorkBlock>
          <StyledMainTitleHomePage
            initial="hidden"
            whileInView="visible"
            viewport={{amount: 0.2}}
            variants={HookResponsive() ? howItWorkTitleAnimation : null}
            className="main-title"
            color="#333333"
            position="center"
            mb="80"
            size="50"
            lineHeight="50"
            weight="700"
          >
            Нow it works:
          </StyledMainTitleHomePage>
          <ContentParentDesktop />
          <ContentParentResponse />
        </StyledHomePageHowItWorkBlock>
      </StyledHomePageContainer>
    </StyledHomePageHowItWorkSection>
  );
};

export default HomePageHowItWork;